import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password: string = control.value ?? '';
    if (!password) {
      return null; // let required validator handle empties
    }

    // Requirements:
    // - at least 8 chars
    // - at least 1 digit
    // - at least 1 special char
    // - at least 1 uppercase
    // - at least 1 lowercase
    const pattern = /^(?=.*[0-9])(?=.*[!@#$%^&*()_\-+={[}\]|\\:;"'<>,.?/~`])(?=.*[A-Z])(?=.*[a-z]).{8,}$/;

    const valid = pattern.test(password);
    return valid ? null : {
      passwordStrength: {
        requiredPattern: pattern.toString(),
        actualLength: password.length,
        hasDigit: /[0-9]/.test(password),
        hasSpecial: /[!@#$%^&*()_\-+={[}\]|\\:;"'<>,.?/~`]/.test(password),
        hasUpper: /[A-Z]/.test(password),
        hasLower: /[a-z]/.test(password),
        minLength: 8
      }
    };

  }
}
